import React, { CSSProperties } from 'react';
import {NodeHealthStatusSummaryDisplay} from './NodeHealthDisplay'
import {NodeHealthData} from '../NodeHealth'
import {UserInvestigationInfo} from '@radnuc/react-ui-components/dist/UserInvestigationDisplay'
import {InvestigationInterface} from '@radnuc/react-ui-components/dist/InvestigationDisplay'

import { BD21ExpertSettingsButton, SuppressedAlertsInterface} from './BD21ExpertSettingsDisplay'
import { ExpertSettingsButton } from '@radnuc/react-ui-components/dist/ExpertSettingsDisplay'
import { AuthenticationInterface } from '@radnuc/react-ui-components/dist/AuthenticationDisplay'
import { LaneDisplayInterface } from '@radnuc/react-ui-components/dist/PrimaryDisplay'
//import { TimeDisplay } from '@radnuc/react-ui-components/dist/StatusComponents'
import Config from '@radnuc/react-ui-components/dist/Config';

import * as messages from '@radnuc/messages';

import '@radnuc/react-ui-components/dist/MetricsDisplay.css';
import '@radnuc/react-ui-components/dist/StatusHeader.css';
import { ModalityFilterInterface, ModalityFilterDisplay } from './ModalityFilterDisplay';
import { CloudUiDisplayInterface } from './CloudUiDisplay';

type PCSResult = messages.Rad.PCSResult;

interface AcknowledgeAlertInterface {
    acknowledge: (key: messages.Rad.Investigation) => void,
    setAlertAcknowledge: (flag:boolean)=> void,
}

const Title: React.FC<{ title: string }> = (props) => {
    return (
        <label className="Title" style={{fontSize:48}}>{props.title}</label>
    )
}

const ConnectionStatus: React.FC<{ connected: boolean }> = (props) => {
    return (
        <div className={"ConnectionStatus StatusBox " + (props.connected ? "connected" : "disconnected")}>
            <span className="value">{props.connected ? 'Connected' : 'Disconnected'}</span>
        </div>
    )
}


interface BD21StatusHeaderProps {
    connected: boolean,
    investigationInterface?: InvestigationInterface,
    modalityFilterInterface?: ModalityFilterInterface,
    cloudUiDisplayInterface?: CloudUiDisplayInterface,
    liveStream: boolean,
    replayTime?: Date,
    headerTitle?: string,
    uiVersionString?: string,
    healthData?: Map<string,NodeHealthData>,
    showTimeDisplay?: boolean,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
}

export class BD21StatusHeader extends React.Component<BD21StatusHeaderProps> {

    /*
    getThisHealthData(component: messages.Rad.HealthComponent){
        let thisHealthData;
        if(this.props.healthData !== undefined){
            thisHealthData = this.props.healthData.get(component);
        }
        return(thisHealthData)
    }
    */

    render() {

        let ui_title:string = '';
        if(this.props.headerTitle !== undefined)
            ui_title = this.props.headerTitle;

        let timeDisplay;
        let healthStatusSummaryDisplay;

        const acknowlegeAlertInterface = this.props.investigationInterface as unknown as AcknowledgeAlertInterface;

        if (this.props.showTimeDisplay){
            timeDisplay= <TimeDisplay liveStream={this.props.liveStream} replayTime={this.props.replayTime} style={{width:'190px',marginTop:'5px',marginBottom:'5px'}}/>
        }
        if(this.props.healthData !== undefined){
            healthStatusSummaryDisplay = <NodeHealthStatusSummaryDisplay healthData={this.props.healthData} cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}/>
        }

        return (
            <div className="StatusHeader">
                <div className="header-left" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
                    <div className="logo"></div>
                    <Title title={ui_title}/>
                    {timeDisplay}
                </div>
                <div className="header-right" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
                    <ModalityFilterDisplay modalityFilterInterface={this.props.modalityFilterInterface}/>
                    <BD21ExpertSettingsButton
                        investigationInterface={this.props.investigationInterface}
                        suppressedAlertsInterface={this.props.suppressedAlertsInterface}
                        uiVersionString={this.props.uiVersionString}/>
                    <ConnectionStatus connected={this.props.connected}/>
                    {healthStatusSummaryDisplay}
                </div>
            </div>
        )
    }
}

interface TimeDisplayProps {liveStream: boolean, replayTime?: Date, style?: CSSProperties | undefined, liveTimeOffsetMS?:number}
interface TimeDisplayState { time: Date }
export class TimeDisplay extends React.Component<TimeDisplayProps,TimeDisplayState,{}> {
    updateInterval:number = 1000; //msec
    updateTimer:NodeJS.Timeout | null = null;
    constructor(props: TimeDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount(){
        if(this.updateTimer !== null){
            clearTimeout(this.updateTimer);
        }
    }

    startTimer(){
        if(this.updateTimer !== null){
            clearTimeout(this.updateTimer);
        }
        this.updateTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.updateInterval)
    }

    render() {
        this.startTimer();
        let timeDisplay;
        if(this.props.liveStream){
            let offset = 0;
            if(this.props.liveTimeOffsetMS !== undefined){
                offset = this.props.liveTimeOffsetMS;
            }
            const time_now = new Date(new Date().getTime()-offset);
            timeDisplay =
                <div className="time-container inv-metric-container" style={this.props.style}>
                    <label className="metric-title">Current Time</label>
                    <label className="metric">{time_now.toLocaleDateString()+' '+time_now.toLocaleTimeString()}</label>
                </div>
        } else {
            let time_replay_string = 'N/A';
            if(this.props.replayTime !== undefined){
                time_replay_string = this.props.replayTime.toLocaleDateString()+' '+this.props.replayTime.toLocaleTimeString();
            }
            timeDisplay =
                <div className="time-container inv-metric-container" style={this.props.style}>
                    <label className="metric-title">Replay Time</label>
                    <label className="metric">{time_replay_string}</label>
                </div>
        }

        return (
            <>
            {timeDisplay}
            </>
        )
    }
}
